import apiUrl from "../ApiConfig";

const ApiPutX4 = (url, obj, func) => {
    async function myAppPost() {
        const res = await fetch(`${apiUrl}${url}`, {
            method: 'PUT',
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(obj)
        }).then(res => {
            if (res.ok) {
                return res.json().then(result => {
                    func(result.result)
                })
            }
        }
        ).catch(err => console.log(err))
    }
    myAppPost()
}
export default ApiPutX4